import { AddStage } from "@forwardflow/modals/MapStageModal/AddStage";
import { AddTag } from "@forwardflow/modals/MapStageModal/AddTag";
import { SelectField } from "@forwardflow/ui";
import Icon from "@forwardflow/ui/Icons";
import { useState } from "react";

export const LeadsMissedAppointments = () => {
  const [edit, setEdit] = useState<boolean>(false);
  const [selected, setSelected] = useState(true);
  const toggleSelected = () => setSelected((s) => !s);
  const [selectedStage, setSelectedStage] =
    useState<string>("FF Default Mapping");
  return (
    <div className="flex justify-between px-10 py-5 bg-primary/10">
      <div className="flex flex-col w-full">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center mt-3 font-medium text-white gap-x-4 mb-7">
            <Icon name="AppointmentScheduled" />
            <span>Leads with missed appointments</span>
          </div>
          <div>
            {!edit ? (
              <button
                onClick={() => setEdit(true)}
                className={`h-10 font-medium rounded bg-white/10 w-28 hover:bg-white/20 transition-all`}
              >
                Edit
              </button>
            ) : (
              <div className="flex gap-x-4">
                <button
                  onClick={() => setEdit(true)}
                  className={`h-10 font-medium rounded bg-white/10 w-28 hover:bg-white/20 transition-all`}
                >
                  Reset
                </button>
                <button
                  onClick={() => setEdit(false)}
                  className={`h-10 font-medium rounded bg-primary hover:bg-primary-dark w-28 transition-all`}
                >
                  Done
                </button>
              </div>
            )}
          </div>
        </div>

        {edit && (
          <p className="border-b border-black/20 text-[12px] mb-7">
            <SelectField
              className="ff-inline-select-border-4 max-w-52"
              defaultValue={"FF Default Mapping"}
              options={[
                {
                  label: "FF Default Mapping",
                  value: "FF Default Mapping",
                },
                {
                  label: "Organization default",
                  value: "Organization default",
                },
                {
                  label: "Advanced Mapping",
                  value: "Advanced Mapping",
                },
              ]}
              onChange={(value) => {
                setSelectedStage(value);
              }}
            ></SelectField>
          </p>
        )}
        <>
          {selectedStage === "FF Default Mapping" ||
          selectedStage === "Organization default" ? (
            <>
              <p className="text-[14px] font-medium mb-4">{selectedStage}</p>
              <p className="text-[12px] text-[#D2D2D2] max-w-[584px] mb-6">
                Once a contact misses an appointment, Forward Flow will follow
                up try to reschedule the appointment. If the appointment is
                rescheduled, we will update the Appointment field in FUB and
                text the agent
              </p>
            </>
          ) : (
            <>
              <div className="pb-3">
                <div className="flex items-center mb-4 gap-x-4">
                  <p className="text-[14px] text-white font-medium">
                    Advanced FUB sync
                  </p>
                </div>
                <p className="text-[12px] text-[#D2D2D2]">
                  Add Stage/Tag to the lead in Follow up Boss, once a contact
                  misses an appointment
                </p>
                <div>
                  <div className="border mt-4 text-[#AAA] cursor-pointer border-white/10 text-[12px] font-medium bg-[#828282]/10 rounded inline-flex w-[260px] h-[38px] overflow-hidden">
                    {["Add Stage", "Add Tag"].map((text, index) => (
                      <div
                        key={text}
                        onClick={toggleSelected}
                        className={`flex-1 flexc gap-x-[10px] leading-none border border-white/10 ${
                          selected === (index === 0)
                            ? "!border-white/50 bg-white/10"
                            : "hover:bg-[#828282]/15"
                        } ${index === 0 ? "rounded-l" : "rounded-r"}`}
                      >
                        <Icon
                          className={`${
                            selected === (index === 0) ? null : " invisible"
                          } -ml-4`}
                          name="Check"
                          width={10}
                          height={10}
                        />

                        <div
                          className={
                            selected === (index === 0) ? "text-white" : ""
                          }
                        >
                          {text}
                        </div>
                      </div>
                    ))}
                  </div>
                  {selected ? <AddStage /> : <AddTag />}
                </div>
              </div>
            </>
          )}
        </>
      </div>
    </div>
  );
};
